module.exports = __webpack_public_path__ + "img/newlogo6.3d0f3e54.png";